import React from 'react'

const RetainerInvoices = () => {
  return (
    <div>RetainerInvoices</div>
  )
}

export default RetainerInvoices